import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import FieldError from '../../common/FieldError';
import { UserBookInfo } from '../common/UserBookInfo';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from 'react-toastify';

export const UserBookModify = ()=>{
    const navigate = useNavigate();
    const { school, book } = useParams();
    const [subject, setSubject] = useState('');
    const [errors, setErrors] = useState([]);
    const queryClient = useQueryClient();

    const { data:userBook } = useQuery({
        queryKey:['userbook', book],
        queryFn:()=>Api.get(`/api/userBook/${book}`),
    });

    useEffect(() => {
        setSubject(userBook?.data?.subject);
    }, [userBook]);

    const storeMutate = useMutation({
        mutationFn:(data)=>Api.post('/api/userBook/store', data),
        onSuccess:(res)=>{
            queryClient.setQueryData(['userbook', book], {...userBook, data:{...userBook.data, subject:subject}});
            navigate({ pathname: `/${school}/userbook/view/${book}`, search: '' });
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err);
            if(errorData.errors.length>0){
                setErrors(errorData.errors);
            }else{
                toast.error(errorData.message);
            }
        }
    });
    

    
    const onSave = ()=>{
        if( storeMutate.isPending ) return;
        if( subject==='' ){
            setErrors([{field:'subject', 'reason':'작품 제목을 적어주세요.'}])
            return;
        }

        setErrors([]);
        storeMutate.mutate({ id:book, subject:subject});
    }



    
    return (
        <div className="userBookCreate modify">
            <UserBookInfo bookId={book} />
            <div className="step inner inputStep">
            
                <div className="row">
                    <div className="col6 col-sm-12 guideContainer ">
                        <div className="explain">
                            <strong>제목을 정해주세요!</strong>
                            <p>자신의 작품과 관련된 제목으로~</p>
                        </div>
                    </div>
                    <div className="col6 col-sm-12 bookgomi">
                        <img src={`${process.env.PUBLIC_URL}/static/images/userbook/new_userbook_title_bookgomi.gif`} alt="북고미"/>
                    </div>
                    <div className="col12">
                        <FieldError name="subject" errors={errors} >
                            <input type="text" className="input_title" placeholder="여러분들의 작품 제목을 입력해주세요." name="subject" maxLength="35" value={subject} onChange={(e)=>{setSubject(e.target.value);} } />
                        </FieldError>
                    </div>
                </div>
                    
                <button className="btn _blue" onClick={onSave}>저장</button>
                &nbsp;
                <Link className="btn _red" to={`/${school}/userbook/view/${book}`}>취소</Link>
            </div>
        </div>
    );
}